import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";

export class ServicePointsRequests {

  /* @ngInject */
  constructor(private servicePointsAPI: BringozApi, private $servicePoints,
              private apiConfig: ApiConfig, private splitService: SplitService,
              private Upload, private $http) {
  }

  createServicePoint(data) {
    const api = this.servicePointsAPI.actions.createServicePoint;
    return this.$$call(api, {}, data, {});
  }

  deleteServicePoint(servicePointId, shouldMask) {
    const api = this.servicePointsAPI.actions.deleteServicePoint;
    return this.$$call(api, {mask: shouldMask}, {}, {id: servicePointId});
  }

  updateServicePoint(servicePointId, data) {
    const api = this.servicePointsAPI.actions.editServicePoint;
    return this.$$call(api, {}, data, {id: servicePointId});
  }

  validateImport(file) {
    const siteId = this.splitService.getSiteId();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/servicepoint/actions/validate`,
      method: 'POST',
      params: {siteId: siteId},
      data: {file: file}
    })
      .then((response) => {
        return response.data;
      });
  }

  importServicePoints(payload) {
    const siteId = this.splitService.getSiteId();
    return this.$http({
      url: this.apiConfig.baseUrl + `/servicepoint/actions/import`,
      method: 'POST',
      params: {siteId: siteId},
      data: payload,
      headers: {'Content-Type': 'application/json'}
    })
      .then((response) => {
        return response.data;
      });
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$servicePoints().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.service-points')
  .service('servicePointsRequests', ServicePointsRequests);
